import styled from "styled-components";

interface IButton {
  children: any;
  onclick: Function;
  disable?: any;
  addonCss?: any;
}
const Button = ({ children, onclick, addonCss, disable = false }: IButton) => {
  return (
    <SButton
      style={addonCss}
      className={disable ? "disable" : ""}
      onClick={() => !disable && onclick()}
    >
      {children}
    </SButton>
  );
};
export default Button;
const SButton = styled.div`
  color: var(--color-text);
  background-color: var(--color-surface);
  width: fit-content;
  cursor: pointer;
  padding: 10px 22px;
  border-radius: var(--radius-sm);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  letter-spacing: 0.02em;
  user-select: none;
  transition:
    transform var(--transition),
    box-shadow var(--transition),
    filter var(--transition),
    background-color var(--transition);
  box-shadow: var(--shadow-xs);

  &:hover {
    filter: brightness(1.05);
    box-shadow: var(--shadow-sm);
    transform: translateY(-1px);
  }
  &:active {
    transform: translateY(0);
    filter: brightness(0.97);
  }
  &.disable {
    cursor: not-allowed;
    opacity: 0.65;
    &:hover {
      transform: none;
      filter: none;
      box-shadow: var(--shadow-xs);
    }
  }
  & > svg {
    height: 20px;
  }
`;
